import React, { useState } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ConflictGroupCard } from "@/components/common/Table/File/ConflictGroupCard";
import { ConflictRuleGroup } from "@/models/ConflictRule";

const keyOf = (group: ConflictRuleGroup) => `${group.outcome}|${group.family}|${group.parentId}|${group.targetPath}`;

/** Groups a rule decided or left alone, each as the resolve drawer shows a group, read-only. */
const RuleGroupList: React.FC<{ groups: ConflictRuleGroup[]; startCollapsed?: boolean }> = ({
  groups,
  startCollapsed = false,
}) => {
  const [toggled, setToggled] = useState<Set<string>>(new Set());

  return (
    <TooltipProvider delayDuration={200}>
      <div className="flex flex-col gap-2">
        {groups.map((group) => {
          const key = keyOf(group);
          return (
            <ConflictGroupCard
              key={key}
              readOnly
              group={group}
              collapsed={toggled.has(key) !== startCollapsed}
              onToggleCollapse={() =>
                setToggled((previous) => {
                  const next = new Set(previous);
                  if (next.has(key)) next.delete(key);
                  else next.add(key);
                  return next;
                })
              }
            />
          );
        })}
      </div>
    </TooltipProvider>
  );
};

export default RuleGroupList;
